import React from 'react';
import { AddressPicker } from '../address-picker';

/* eslint-disable react/prop-types */
export function AddressPickerAdapter({ input, meta, ...rest }) {
  return <AddressPicker {...input} {...rest} meta={meta} />;
}
